// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"777a0f0b","129":"c6fda246","225":"9431e85e","277":"89d48c11","334":"762e75a6","477":"c56fa8f5","554":"108a1761","586":"4811a847","606":"03eab1eb","719":"f0797768","851":"5433f2c2"}[chunkId] + ".chunk.js";
};